import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const ChartBarHorizontal = ({ data, labels }) => {
  const [chartData] = useState({
    series: [{
      name: 'Cantidad de registros',
      data: data ?? [0]
    }],
    options: {
      annotations: {
        points: [{
          x: '1994',
          seriesIndex: 0,
          label: {
            borderColor: '#775DD0',
            offsetY: 0,
            style: {
              color: '#fff',
              background: '#775DD0',
            },
            text: 'Año clave',
          }
        }]
      },
      // chart: {
      //   height: 400,
      //   type: 'bar',
      //   id: "basic-bar",
      //   margin: {
      //     left: 260
      //   }
      // },
      plotOptions: {
        bar: {
          borderRadius: 10,
          columnWidth: '50%',
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        offsetY: -20,
        style: {
          fontSize: '14px',
          colors: ["#304758"]
        }
      },
      stroke: {
        width: 0
      },
      grid: {
        row: {
          colors: ['#fff', '#f2f2f2']
        }
      },
      xaxis: {
        labels: {
          rotate: -45
        },
        categories: labels ?? ['Sin datos'],
        tickPlacement: 'on',
      },
      chart: {
        height: 400,
        type: 'bar',
        id: "basic-bar",
      },
      yaxis: {
        title: {
          text: 'Cantidad de consultas'
        },
        labels: {
          style: {
            color: "#000",
          },
          maxWidth: 250 // Espacio reservado para los labels
        }
      },
      fill: {
        colors: ['#BC955B']
      }
    },
  });

  return (
    <div style={{ width: "100%" }}>
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={400}
        width="100%"
      />
    </div>
  );
};

export default ChartBarHorizontal;
